$('#modalVideo').on('hidden.bs.modal', function (event) {
    let media = $('video').get(0);
    media.pause();
    media.currentTime = 0;
});

$('#modalVideo').on('show.bs.modal', function (event) {
    let media = $('video').get(0);
    media.play();
});
